import {FETCH_INTERNSHIPLIST_REQUEST, FETCH_INTERNSHIPLIST_SUCCES, FETCH_INTERNSHIPLIST_ERROR} from '../constants/InternshipList'
import { jsonGet, errorHandler } from '../utils/Request';

const loadInternshipList = () => (dispatch) => {
  const apiUrl = '/internship/list/';
  dispatch({
    type: FETCH_INTERNSHIPLIST_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_INTERNSHIPLIST_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_INTERNSHIPLIST_ERROR
      });
      errorHandler(e);
    });
};

export { loadInternshipList };



// WEBPACK FOOTER //
// ./src/actions/InternshipListActions.js